<template>
  <Layout>
    <div class="p-16 w-full max-w-[100rem]">
      <h2 class="text-[40px] font-[900] mb-6 capitalize text-left">Events</h2>
      <!-- Search and Filter Controls -->
      <div class="mb-8 flex flex-col md:flex-row md:items-center gap-4 max-w-[66rem]">
        <input type="text" v-model="searchQuery" placeholder="Search by event name..."
          class="p-2 border border-gray-300 rounded-md md:flex-grow focus:ring-2 focus:ring-[#00395a] focus:border-transparent" />
        <input type="date" v-model="filterStartDate"
          class="p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#00395a] focus:border-transparent"
          title="Filter start date" />
        <input type="date" v-model="filterEndDate"
          class="p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#00395a] focus:border-transparent"
          title="Filter end date" />
      </div>

      <div v-if="filteredEvents.length > 0" class="grid grid-cols-1">
        <div v-for="(event, index) in filteredEvents" :key="event.id || index"
          class="flex flex-col sm:flex-row items-start w-full mb-20">
          <div
            class="bg-[#00395a] text-white text-center w-16 h-16 flex flex-col items-center justify-center mr-4 lg:mr-10 rounded">
            <template v-if="loadingEvents">
              <div class="animate-pulse w-full h-full flex flex-col items-center justify-center">
                <div class="bg-gray-300 rounded w-10 h-4 mb-2"></div>
                <div class="bg-gray-300 rounded w-10 h-6"></div>
              </div>
            </template>
            <template v-else>
              <h3 class="text-lg sm:text-xl">{{ getDayOfWeek(event.linkDate) }}</h3>
              <h3 class="font-[9  00] text-2xl sm:text-3xl -mt-1">{{ getDayOfMonth(event.linkDate) }}</h3>
            </template>
          </div>
          <!-- <img :src="event.linkImage" class="block sm:hidden w-full sm:w-48 md:w-64 h-40 sm:h-auto object-cover rounded-md mr-0 sm:mr-6 mb-4 sm:mb-0 flex-shrink-0 mt-4"> -->
          <div class="flex flex-col justify-start text-left w-full sm:w-[50%]">
            <div class="bg-gray-300 rounded w-32 h-3 mb-2 mt-4" v-if="loadingEvents"></div>
            <p class="text-black  text-sm sm:text-base mb-2" v-else>{{ getFormattedDate(event.linkDate) }}</p>
            <a :href="event.linkMedia"
              class="text-[#00395a] mr-auto group-hover:underline font-[900] text-xl sm:text-2xl">{{
                event.linkName }}</a>
            <p class="text-black  text-base sm:text-lg font-[500] max-w-3xl">{{ event.linkDescription }}</p>
          </div>
          <!-- <img :src="event.linkImage" class="ml-4 hidden sm:block w-full sm:w-48 md:w-64 h-40 sm:h-auto object-cover rounded-md mr-0 sm:mr-6 mb-4 sm:mb-0 flex-shrink-0">    -->
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from './../layouts/LayoutView.vue';
import axiosInstance from '@/utils/axiosInstance';
export default {

  name: 'HomeEvents',
  components: {
    Layout
  },
  props: {
    // eventItems: {
    //   type: Array,
    //   required: true,
    // }
  },
  data() {
    return {
      eventItems: [],
      searchQuery: '',
      filterStartDate: null,
      filterEndDate: null,
      loadingEvents: true,
    };
  },
  computed: {
    sourceEvents() {
      // Prioritize prop data if available, otherwise use local data
      console.log('Source Events:', this.eventItems);
      return this.eventItems && this.eventItems.length > 0 ? this.eventItems : '[]';
    },
    filteredEvents() {
      console.log('Filtering Events:', this.sourceEvents);
      let eventsToFilter = [...this.sourceEvents];

      // Filter by search query (event name/title)
      if (this.searchQuery) {
        const lowerSearchQuery = this.searchQuery.toLowerCase();
        eventsToFilter = eventsToFilter.filter(event =>
          event.linkName && event.linkName.toLowerCase().includes(lowerSearchQuery)
        );
      }

      // Filter by start date
      if (this.filterStartDate) {
        eventsToFilter = eventsToFilter.filter(event =>
          new Date(event.linkDate) >= new Date(this.filterStartDate)
        );
      }

      // Filter by end date
      if (this.filterEndDate) {
        // To make the end date inclusive, we compare against the start of the *next* day
        const inclusiveEndDate = new Date(this.filterEndDate);
        inclusiveEndDate.setDate(inclusiveEndDate.getDate() + 1);
        eventsToFilter = eventsToFilter.filter(event =>
          new Date(event.linkDate) < inclusiveEndDate
        );
      }

      return eventsToFilter;
    }
  },
  async created() {
    try {
      const response = await axiosInstance.get('home-page?&populate[upcomingEventsLinkList][populate]=*');
      const responseAttributes = response.data.data.attributes;
      this.eventItems = responseAttributes.upcomingEventsLinkList.map(item => ({
        ...item,
      }));
      this.loadingEvents = false; // <-- Set loading to false
    } catch (error) {
      console.error('Failed to fetch Events:', error);
      this.loadingEvents = false; // <-- Also set loading to false on error
    }
  },
  methods: {
    getFormattedDate(dateString) {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(dateString).toLocaleDateString('en-US', options);
    },

    getDayOfWeek(dateString) {
      const date = new Date(dateString);
      const options = { weekday: 'short' };
      return date.toLocaleDateString('en-US', options);
    },

    getDayOfMonth(dateString) {
      const date = new Date(dateString);
      return date.getDate();
    },

    // Methods can be added here if needed
  }
};
</script>